<template>
	<div>
		<div class="page-title">
			<icon-font type="icon-zidingyimoxing" class="title-icon" style="margin-right: 12px"/>
			<span>自定义分析</span>
			<a-button v-if="activeKey === 'normal'" type="primary" class="create-btn" @click="$router.push({
				name: 'modelDesign'
			})"><icon-font type="icon-Save" />新建</a-button>
			<a-button class="filter-btn btn-tertiary" @click="filterVisible = !filterVisible"> 
        <icon-font type="icon-Filter1"  /><span>筛选</span>
    	</a-button>
		</div>
		<div class="page-filter" v-if="filterVisible">
			<a-form-model ref="form" :model="params">
				<a-form-model-item label="模板名称" prop="name">
					<a-input v-model.trim="params.name" placeholder="请输入查询条件"></a-input>
				</a-form-model-item>
				<a-form-model-item label="创建人" prop="userEmail" v-if="activeKey !== 'normal'">
					<a-select
            v-model="params.userEmail"
            :showSearch="true"
            :filter-option="false"
            placeholder="请输入创建人或分享人"
            @search="searchModel"
          >
            <a-select-option v-for="item in tableList" :key="item.loginName" :value="item.loginName">
              <div>{{ item.userName }}</div>
            </a-select-option>
            </a-select>
				</a-form-model-item>
				<div class="handle-btn">
					<a-button type="primary" @click="search">查询</a-button>
					<a-button @click="reset">重置</a-button>
				</div>
			</a-form-model>
		</div>
    <a-tabs v-model="activeKey" type="card" class="page-tabs" @change="changeTabs">
        <a-tab-pane key="normal" tab="我的模型"></a-tab-pane>
        <a-tab-pane key="default" tab="下级数据"></a-tab-pane>
        <a-tab-pane key="internal" tab="他人分享"></a-tab-pane>
    </a-tabs>
    <template v-if="activeKey === 'normal'">
      <div class="page-table" ref="cont">
        <vxe-grid
        border="inner"
        auto-resize
          :columns="columns"
          :column-config="{resizable: true}"
          :data="data"
          show-overflow
          size="small"
          :row-config="{isCurrent: true, isHover: true}"
          :loading="loading"
          :empty-render="{name: 'NotData'}"
        >
          <template #name="{row}">
            <div>
              <div style="line-height: 20px">{{row.name}} <span v-show="row.shareMedia" class="success">Media已分享</span></div>
              <div class="model-id">ID{{row.analysisTemplateId}}</div>
            </div>
          </template>
          <template  #handle="{row}">
            <div class="table-handle-btn">
              <a-tooltip placement="top" title="查看">
                <icon-font @click="viewClick(row)" class="view-btn" type="icon-Eye-Open"/>
              </a-tooltip>
              <a-tooltip placement="top" title="编辑">
                <icon-font @click="editClick(row)" class="edit-btn" type="icon-Edit"/>
              </a-tooltip>
              <a-tooltip placement="top" title="复制">
                <icon-font @click="copyClick(row)"  class="copy-btn" type="icon-Copy"/>
              </a-tooltip>
              <a-tooltip placement="top" title="分享">
                <icon-font @click="handleOpenShare(row)" class="edit-btn" type="icon-Share"/>
              </a-tooltip>
              <a-tooltip placement="top" title="分享历史">
                <icon-font @click="handleOpenShareHistory(row)" class="edit-btn" type="icon-lishi"/>
              </a-tooltip>
              <a-tooltip placement="top" title="删除">
                <icon-font class="delete-btn" @click="handleDel(row)" type="icon-Delete"/>
              </a-tooltip>
            </div>
          </template>
        </vxe-grid>
        <a-pagination
        class="mt-16 mb-16 df-end"
        v-if="(data &&data.length > 0)"
        size="small"
        :pageSize="pagination.pageSize"
        :total="pagination.total"
        :current="pagination.current"
        @change="(page, pageSize) => handleTableChange(page,pageSize)"
      />
      <addShare ref="addShare" :record="currentRow" @success="getList()"></addShare>
      <shareHistory ref="shareHistory" :record="currentRow" @refreshList="getList()"></shareHistory>
      </div>
    </template>
    <template v-else>
      <shareList ref="default" :tabKey="activeKey"></shareList>
    </template>
    <!-- <template v-else-if="activeKey === 'internal'">
      <shareList ref="internal" :activeKey="activeKey"></shareList>
    </template> -->
	</div>
</template>
<script>
import { getAnalysisTemplates, deleteAnalysisTemplate, checkDeleteAnalysisTemplate, copyBaseTemplate, validExclusive } from '@/api/template'
import {  getUserNames } from "@/api/shareModal"
import addShare from "./shareComponents/addShare.vue"
import shareHistory from "./shareComponents/shareHistory.vue"
import shareList from "./shareComponents/shareList.vue"
const columns = [
	{
		title: '模型名称',
		field: 'name',
    slots: { default: 'name' },
		align: 'left',
		// width: 270,
	},
	{
		title: '创建人',
		field: 'creator',
		align: 'left',
		// width: 160,
	},
	{
		title: '创建时间',
		field: 'createTime',
		align: 'left',
		// width: 180,
	},
  {
		title: '操作',
		field: 'handle',
		align: 'left',
    slots: { default: 'handle' },
		// width: 151,
	},
]
export default {
	name: 'UserDefinedModel',
	data() {
		return {
			activeKey: 'normal',
			loading: false,
			pagination: {
				current: 1,
				total: 0,
				pageSize: 10,
        showTotal: total => `共${total}条`
			},
			params: {
				name: '',
        userEmail: undefined,
			},
			data: [],
			filterVisible: false,
			columns,
      currentRow: {},
      tableList: [],
		}
	},
  watch: {
    activeKey() {
      this.$router.push({
        query: {
          activeKey: this.activeKey
        }
      })
    }
  },
	methods: {
    searchModel(val){
      this.fetchModel(val);
    },
    fetchModel(val) {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }
      this.timeout = setTimeout(() => {
        this.getModelList(val);
      }, 500);
    },
    getModelList(userName) {
      this.loading = true
      getUserNames({
        userName
      }).then((res) => {
        this.tableList = this.$deepclone(res.data) || []
      }).finally(() => this.loading = false)
    },
    handleOpenShare(record){
      this.$refs.addShare.visible = true;
      this.currentRow = record;
    },
    handleOpenShareHistory(record){
      this.$refs.shareHistory.visible = true;
      this.currentRow = record;
    },
		reset() {
			this.resetFields()
			// this.pagination.current = 1
			// this.getList()
      this.search();
		},
    changeTabs(){
      this.resetFields()
      this.search();
    },
    resetFields(){
      this.params.name = ""
      this.params.userEmail = undefined
    },
		search() {
      if(this.activeKey === 'normal'){
        this.pagination.current = 1
			  this.getList()
      }else  {
        this.$nextTick(()=> {
          this.$refs.default.getList(this.params, 1)
        })
      }
		},
		// 复制
		copyClick(record) {
			this.loading = true
			copyBaseTemplate(record.analysisTemplateId).then(res => {
				this.editClick({
					analysisTemplateId: res.data
				})
			}).finally(() => this.loading = false)
    },
		// 预览
		viewClick(record) {
      let routeUrl = this.$router.resolve({
        path: "/modelViewer",
        query: {
          reportCode: record.analysisTemplateId,
					backUrl: location.href
        }
      });
      window.open(routeUrl.href, "_blank");
		},
		openEC() {
			window.open('http://adpub.yeahtargeter.com/', '_blank')
		},
		getList(searchKeyWord) {
      this.loading = true
      getAnalysisTemplates({
        pageSize: this.pagination.pageSize,
        pageNo: this.pagination.current,
        ...this.params
      }).then((res) => {
        this.data = res.data.recordList || []
        this.pagination.total = res.data.recordCount
      }).finally(() => this.loading = false)
    },
		handleTableChange(page) {
			const pager = { ...this.pagination, current:page };
			 
			this.pagination = pager;
      this.getList()
		},
		editClick(record) {
			validExclusive(record.analysisTemplateId).then(res => {
        this.$router.push({
          name: 'modelDesign',
          query: {
            reportCode: record.analysisTemplateId,
            name: record.name
          }
        })
      })
		},
    async handleDel(record){
      const res  = await checkDeleteAnalysisTemplate(record.analysisTemplateId)
      const { code, msg } = res;
      let newMsg = ''
      let newTitle = '是否删除该模型?'
      if(code === 200){
        newMsg = ""
        // newTitle = "确认要删除这个模型吗?"
      }else if(code === 500100){
        newMsg = `${msg}`
      }
      const that = this;
      this.$confirm({
        title: newTitle,
        class: 'cont-confirm',
        content: `${newMsg}`,
        onOk() {
          that.deleteClick(record)
        },
        onCancel() {
          console.log('Cancel');
        },
        class: 'test',
      });
      console.log(res)
    },
		// 删除分析模型
		deleteClick(record) {
      deleteAnalysisTemplate(record.analysisTemplateId).then((res) => {
				this.$message.success('删除成功！')
				if(this.data.length === 1) {
					this.pagination.current = 1
				}
				this.getList()
      })
		}
	},
  created(){
    const activeKey = !!this.$route.query.activeKey ? this.$route.query.activeKey : ''
    if(activeKey){
      this.activeKey = activeKey;
    }else {
      this.activeKey = 'normal'
    }
    console.log(activeKey, 'query');
  },
	mounted() {
		this.search()
	},
	components: {
    addShare,
    shareList,
    shareHistory
  },
}
</script>
<style>
  .ant-modal-confirm-content{
    white-space: pre-line;
  }
</style>
<style lang="less" scoped>
	.edit-btn, .delete-btn, .copy-btn {
		margin-left: 16px;
	}
	.view-btn,.copy-btn, .edit-btn, .delete-btn {
		cursor: pointer;
		font-size: 16px;
		vertical-align: middle;
	}
	.model-id {
		color: #9CA9CB;
		line-height: 20px;
		font-size: 12px;
	}
  .page-tabs {
		// margin-top: 24px;
		padding-left: 24px;
		/deep/ .ant-tabs-bar {
			border-bottom: none;
		}
	}
  .success {
		line-height: 22px;
		background: #F2FAF3;
		border-radius: 4px;
		font-size: 12px;
		color: #22AC35;
		padding: 0 8px;
		display: inline-block;
	}

</style>